<template lang="pug">
  DataTablePage(
    ref="historyTable"
    mainColumn=""
    longColumn=""
    title="用水历史"
    label="用水"
    labelName=""
    :resource="resource"
    :toolbar="toolbar"
    :operation="operation"
    :operationWidth=195
    :updateList="updateList"
    :tableFullList="tableFullList"
    :tableInitList="tableInitList"
    :filterFullList="filterFullList"
    :filterInitList="filterInitList"
    :columns="columns"
    @getData="getCountInitStatus"
    @checkGroupValue="checkGroupValue")
</template>
<script>
import DataTablePage from '@/containers/DataTablePage'
import columns from './waterColumns.js'
import { operationUpdate } from '@/containers/DataTablePage/operation'
import { fetchBatch, fetchItem, fetchUpdate, fetch } from '@/utils/api'
import { URL } from '@/utils/common'
import { map } from 'lodash'
import { expire } from '@/utils/auth'
export default {
  name: 'WaterList',
  components: {
    DataTablePage
  },
  data () {
    return {
      toolbar: [{
        label: '批量点抄',
        type: 'complete',
        funcProps: {
          el: this
        },
        func ({funcProps}) {
          const { el } = funcProps
          const counterId = el.findCounterId(el.checkGroup)
          el.requireReading(counterId)
        }
      }, {
        label: '批量回填',
        funcProps: {
          el: this
        },
        func ({funcProps}) {
          const { el } = funcProps
          const counterId = el.findCounterId(el.checkGroup)
          if (!counterId.length) {
            this.$swal('错误', '请选择需要批量回填数据', 'info')
            return
          }
          fetchBatch({
            url: '/meterPayload/data/batchBackfill',
            ids: counterId
          }).then(res => {
            if (res) {
              this.$swal('批量回填成功', '', 'success')
            }
            el.refreshTable()
          })
        }
      }],
      /**
      * 操作按钮
      */
      operation: [{
        label: '点抄',
        icon: 'eventLog',
        tooltip: true,
        buttonType: 'success',
        funcProps: {
          el: this
        },
        isShow (data) {
          // 当前进入如果状态为点抄中，则不显示
          return data.readingStatus !== 'processing'
        },
        func ({funcProps}) {
          const { button, data, el } = funcProps
          button.buttonType = el.statusType
          el.handleSingleReading(data.counterId)
        }
      }, {
        ...operationUpdate,
        isShow (data) {
          return !data.backfillStatus
        }
      }, {
        label: '回填数据',
        icon: 'refresh',
        tooltip: true,
        funcProps: {
          el: this
        },
        isShow (data) {
          return !data.backfillStatus
        },
        func ({funcProps}) {
          const { data, el } = funcProps
          el.setDataBack(data.counterId, (data) => {
            this.disabled = Boolean(data)
            this.buttonType = data ? 'success' : 'error'
            this.buttonLabel = data ? '回填成功' : '回填失败'
            if (data) this.$swal('回填成功', '', 'success')
          })
        }
      }, {
        label: '查看抄表历史',
        icon: 'meterRecords',
        tooltip: true,
        func ({funcProps}) {
          const { data } = funcProps
          const counterId = data.counterId
          this.$router.push({
            path: `/telnetReading/history/${counterId}`
          })
        }
      }],
      copyTableData: [], // table列表数据
      checkGroup: [], // 勾选的数组
      /**
      * 点抄参数
      **/
      readingstatus: 'ready',
      statusType: 'success',
      statusText: '点抄', // 点抄按钮名称
      counterId: 0,
      resource: '/meterPayload/history/base',
      tableFullList: ['checkBox', 'period', 'hno', 'hname', 'addr', 'readingStatus', 'cost', 'lnum', 'lquanty', 'num', 'quanty', 'wave', 'image', 'counterCode', 'areaPathName', 'phone', 'mobile'],
      tableInitList: ['checkBox', 'period', 'hno', 'hname', 'addr', 'readingStatus', 'lnum', 'lquanty', 'num', 'quanty', 'image', 'counterCode', 'areaPathName', 'phone', 'mobile'],
      filterFullList: ['hname', 'hno', 'areaId'],
      filterInitList: ['hname', 'hno', 'areaId'],
      updateList: ['num'],
      columns: {
        ...columns,
        hno: {
          label: '户号',
          type: 'input',
          // link: true,
          // link: `/telnetReading/history?counterId=${this.$refs.historyTable.counterId}`,
          width: 110,
          form: {
            type: 'input',
            size: 10,
            columnSize: [{
              type: 'md',
              size: 6
            }, {
              type: 'sm',
              size: 12
            }]
          },
          filter: {
            type: 'input',
            width: 100,
            like: true
          }
        },
        image: {
          label: '抄表行码',
          width: 220,
          type: 'custom',
          html: true,
          magnifying: {
            height: '180px',
            width: '200px'
          },
          style: {
            textAlign: 'center'
          },
          customRender (data, full, index) {
            return `<img src="${URL}/${data}" style="height:24px"></img>`
          }
        },
        readingStatus: {
          label: '点抄状态',
          type: 'select',
          width: 100,
          options: [{
            label: '允许点抄',
            value: 'ready'
          }, {
            label: '正在点抄',
            value: 'processing'
          }, {
            label: '点抄失败',
            value: 'failed'
          }, {
            label: '点抄成功',
            value: 'finish'
          }]
        }
      },
      /**
       * 第几次监听进行中的任务，用于防止重复监听
      */
      listenProgressTimes: 0,
      /**
      * 当前点抄id数组
      */
      readingIdsGroup: [],
      processingNum: 0
    }
  },
  watch: {
    statusType (status) {
      this.renderRecord(status)
    }
  },
  mounted () {
    let result = expire()
    if (!result) {
      this.$router.push('/login')
    }
    this.renderRecord('processing')
  },
  methods: {
    /* 点抄-- 根据后台返回的status状态改变，只有processing会每隔3秒轮询点抄接口
      初始页面根据列表接口返回的status，如果为finsh或ready，需要再次调用点抄接口查询到状态
      如果为processing时，则进行轮询
      @statusText 按钮名称，显示当前状态
      @isClick 判断是点击点抄，则为true，是轮询，false
    */
    // 初始化时获取点抄状态
    getCountInitStatus (data) {
      this.copyTableData = data.data
      const readingIdsGroup = data.data.filter(item => { return item.readingStatus === 'processing' })
      // const finishIdsGroup = data.data.filter(item => { return item.readingStatus === 'finish' })
      if (readingIdsGroup.length) {
        // 状态为processing，继续轮询点抄
        const readingIds = map(readingIdsGroup, 'counterId')
        // this.readingIdsGroup = readingIds
        console.info('get::', readingIds)
        this.requireReading(readingIds)
      }
      // else if (finishIdsGroup.length) {
      //   // 点抄成功需要再调点抄接口，转为ready......
      //   const finishIds = map(finishIdsGroup, 'counterId')
      //   console.info('get--finish::', finishIds)
      //   finishIdsGroup.map(item => {
      //     setTimeout(() => {
      //       this.requireSingleReading(item.counterId, finishIdsGroup.length, true)
      //     }, 500)
      //   })
      // }
    },
    renderProcessData () {
    },
    findCounterId (datas) {
      return datas.map(data => {
        return this.copyTableData.find(res => {
          return res.id === data
        }).counterId
      })
    },
    // 刷新table
    refreshTable () {
      this.$refs.historyTable.getData()
    },
    /*
    *返回点抄状态
    */
    renderRecord (status) {
      const statusText = status === 'processing' ? '点抄中'
            : status === 'failed' ? '点抄失败'
            : status === 'finish' ? '点抄完成'
            : '点抄' // 按钮显示的内容
      const statusType = status === 'processing' ? 'info'
            : status === 'failed' ? 'danger'
            : status === 'finish' ? 'success'
            : 'default' // 按钮显示类型
      this.statusText = statusText
      this.readingstatus = status
      this.statusType = statusType
      // console.info('点抄状态: ', statusType, statusText, status)
    },
    /**
    * 单个点抄,根据数组轮询，存放id于数组，点抄成功则移除该id
    **/
    handleSingleReading (id) {
      if (this.readingIdsGroup.indexOf(id) === -1) {
        this.readingIdsGroup.push(id)
      }
      const groupLen = this.readingIdsGroup.length
      // this.listenProgressTimes = groupLen
      this.requireSingleReading(id, groupLen)
    },
    /* 单个请求点抄 */
    requireSingleReading (id, times, isInit = false) {
      fetchItem({
        resource: '/meterPayload/data/totalDataCopy',
        id: id
      }).then(data => {
        if (data.status === 'processing') {
          console.info('this.readingIdsGroup:', this.readingIdsGroup, times)
          this.listenReadingStatus(this.readingIdsGroup, this.listenProgressTimes + 1)
        } else {
          this.refreshTable()
        }
      })
    },
    /**
    * 点抄请求发起，批量操作
    * @ids  执行操作id   Array
    * @time 当前执行数量 number
    **/
    requireReading (ids) {
      if (!ids.length) {
        this.$swal('错误', '请选择需要批量点抄数据', 'info')
        return
      }
      fetchBatch({
        url: '/meterPayload/data/batchReading',
        ids: ids
      }).then(res => {
        this.listenReadingStatus(ids, this.listenProgressTimes + 1)
      })
    },
    /**
    * 监听请求点抄状态
    **/
    listenReadingStatus (ids, times) {
      console.info('listen-status::', ids, this.listenProgressTimes, times)
      // 判断是不是新的监听，是的话更改监听次数
      if (this.listenProgressTimes < times) {
        this.listenProgressTimes = times
      }
      // 判断当前监听是不是最新监听，是的话才执行请求
      if (this.listenProgressTimes === times) {
        fetch({
          url: '/meterPayload/data/batchReadingStatus',
          params: {
            ids: ids.join(',')
          }
        }).then(data => {
          if (data) {
            // 当前是否还有未点抄完成的，有则继续
            if (data.processingNum) {
              const that = this
              const processStatus = data.datas.filter(item => { return item.status === 'processing' })
              const processingIds = processStatus.map(res => {
                return res.counterId
              })
              // that.renderRecord(processStatus)
              that.progressListener = setTimeout(function () {
                that.listenReadingStatus(processingIds, times)
              }, 5000)
            }
            // 有已停止点抄的或不需要继续点抄
            if (this.processingNum !== data.processingNum || data.processingNum === 0) {
              this.processingNum = data.processingNum
              this.refreshTable()
            }
          }
        })
      }
    },
    /*
    *完成后init点抄状态
    */
    // initReadingStatus (ids) {
    //   console.info('ids:', ids)
    //   fetchItem({
    //     resource: '/meterPayload/data/totalDataCopy',
    //     id: id
    //   }).then(data => {
    //     if (data) {
    //       this.refreshTable()
    //     }
    //   })
    // },
    /**
    * 数据回填
    **/
    setDataBack (countId, callback) {
      fetchUpdate({
        resource: `/meterPayload/data/totalDataBackfill`,
        id: countId
      }).then(data => {
        callback ? callback(data) : null
      })
    },
    /**
    * 多选
    */
    checkGroupValue (value) {
      this.checkGroup = value
    },
    renderTableData (data) {
      this.copyTableData = data.data
    }
  },
  destroyed () {
    // clearTimeout(this.progressListener)
  }
}
</script>



// WEBPACK FOOTER //
// WaterList.vue?68d561c2